// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"0dd31f08","801":"de01e78b"}[chunkId] + ".chunk.js";
};